import React, { useState, useEffect } from "react";
import api from "../../api/axiosConfig";
import TaskTemplate from "./TaskTemplate";
import EstimateTaskTemplate from "./EstimateTaskTemplate";
import EditIcon from "@mui/icons-material/Edit";
const fetchData = async (url, setData, setError, setLoading) => {
  setLoading(true);
  try {
    const response = await api.get(url);
    setData(response.data);
    setLoading(false);
  } catch (error) {
    console.error("Error fetching data:", error);
    setError(error);
  } finally {
    setLoading(false);
  }
};
const ProjectSettings = () => {
  const [statusOptions, setStatusOption] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newStatus, setNewStatus] = useState({ name: "", color: "" });
  const [createStatusDial, setCreateStatusDial] = useState(false);
  const [deleteStatusDial, setDeleteStatusDial] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [statusEditable, setStatusEditable] = useState(false);
  const [statusToEdit, setStatusToEdit] = useState("");
  const [selectedStatusIds, setSelectedStatusIds] = useState([]);
  const [openSection, setOpenSection] = useState(
    localStorage.getItem("projectSettings") || "status"
  );
  const handleCheckboxChangeForTemplate = (templateId) => {
    setSelectedStatusIds((prevSelectedTaskTemplateIds) => {
      if (prevSelectedTaskTemplateIds.includes(templateId)) {
        return prevSelectedTaskTemplateIds.filter((id) => id !== templateId); // Remove from selected
      } else {
        return [...prevSelectedTaskTemplateIds, templateId]; // Add to selected
      }
    });
  };

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? section : section);
  };

  useEffect(() => {
    fetchData("/api/status", setStatusOption, setError, setLoading);
  }, []);
  const handleAddNewStatus = async () => {
    try {
      // Check if the role name is not empty
      if (!newStatus.name.trim()) {
        alert("Role name cannot be empty");
        return;
      }

      // Send POST request to create a new role
      const response = await api.post("/api/status", {
        name: newStatus.name,
        color: newStatus.color,
      });
      // Handle the response
      if (response.status === 201) {
        setStatusOption((prev) => {
          if (!prev.some((item) => item.id === response.data.status.id)) {
            return [...prev, response.data.status];
          }
          return prev; // If already exists, return unchanged state
        });
        alert("Status added successfully!");
        setCreateStatusDial(false);
        setNewStatus({ name: "", color: "" }); // Clear the input field
      }
    } catch (error) {
      console.error("Failed to add new role:", error);
      alert("Failed to add role. Please try again.");
    }
  };
  const handleEditStatus = async () => {
    try {
      // Check if the status name is not empty
      if (!newStatus.name.trim()) {
        alert("Status name cannot be empty");
        return;
      }
      // Send PUT request to update the status
      const response = await api.put(`/api/status/${statusToEdit}`, {
        name: newStatus.name,
        color: newStatus.color,
      });

      // Handle response
      if (response.status === 200) {
        // Update the status in state
        setStatusOption((prev) =>
          prev.map((item) =>
            item.id === statusToEdit
              ? { ...item, ...response.data.status }
              : item
          )
        );
        alert("Status updated successfully!");
        setCreateStatusDial(false);
        setNewStatus({ id: null, name: "", color: "" }); // Reset input fields
      }
    } catch (error) {
      console.error("Failed to update status:", error);
      alert("Failed to update status. Please try again.");
    }
  };

  const handleDeleteStatus = async (selectedStatusIds) => {
    try {
      // Send DELETE request with the selectedStatusIds array in the body
      const response = await api.delete(`/api/status`, {
        data: { statusIds: selectedStatusIds }, // Send array in request body
      });

      if (response.data.message === "Statuses deleted successfully") {
        // Remove deleted statuses from state
        setStatusOption((prevStatuses) =>
          prevStatuses.filter(
            (status) => !selectedStatusIds.includes(status.id)
          )
        );
        setSelectedStatusIds([]);
        setDeleteStatusDial(false);
        alert("Statuses deleted successfully");
      }
    } catch (error) {
      console.error("Error deleting statuses:", error);
      alert("Failed to delete the statuses.");
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          whiteSpace: "nowrap",
        }}
      >
        <p
          style={{ marginRight: "15px" }}
          onClick={() => toggleSection("status")}
          className={`project-settings-label ${
            openSection === "status" ? "active" : ""
          }`}
        >
          Scope
        </p>
        <p
          style={{ marginRight: "15px" }}
          onClick={() => toggleSection("tasktemplate")}
          className={`project-settings-label ${
            openSection === "tasktemplate" ? "active" : ""
          }`}
        >
          Task Template
        </p>
        <p
          style={{ marginRight: "15px" }}
          onClick={() => toggleSection("estimatetemplate")}
          className={`project-settings-label ${
            openSection === "estimatetemplate" ? "active" : ""
          }`}
        >
          Estimate Template
        </p>
      </div>
      {openSection === "status" && (
        <div className="project-setting-color">
          {selectedStatusIds.length > 0 && (
            <button
              onClick={() => setDeleteStatusDial(true)}
              className="delete-template-status"
            >
              Delete
            </button>
          )}
          <button
            onClick={() => setCreateStatusDial(true)}
            className="add-template-status"
          >
            Add Status
          </button>
          <ul style={{ margin: "0" }}>
            {statusOptions.map((status) => (
              <div style={{ display: "flex" }}>
                <li className="template-names">
                  <span>
                    <input
                      style={{ cursor: "pointer" }}
                      type="checkbox"
                      checked={selectedStatusIds.includes(status.id)}
                      onChange={() =>
                        handleCheckboxChangeForTemplate(status.id)
                      }
                    />
                  </span>
                  <span>{status.name}</span>
                  <span>{status.color}</span>
                  <span className="edit-icon-wrapper">
                    <EditIcon
                      onClick={() => {
                        setNewStatus({
                          name: status.name,
                          color: status.color,
                        });
                        setStatusEditable(true);
                        setStatusToEdit(status.id);
                        setCreateStatusDial(true);
                      }}
                      style={{
                        backgroundColor: "transparent",
                        color: "blue",
                        cursor: "pointer",
                      }}
                    />
                  </span>
                </li>
              </div>
            ))}
          </ul>
          {createStatusDial && (
            <div className="add-status-dial">
              <div className="add-status-settings">
                <div className="add-role-header-projectsettings">
                  <h3 className="add-new-user-heading">
                    {statusEditable ? "Edit Status" : "Add New Status"}
                  </h3>
                </div>
                <h3 className="label-header-element">Status Name</h3>
                <input
                  className="user-element"
                  placeholder="Enter Status Name"
                  type="text"
                  value={newStatus.name}
                  onChange={(e) =>
                    setNewStatus({ ...newStatus, name: e.target.value })
                  }
                />
                <h3 className="label-header-element">Color</h3>
                <input
                  className="user-element"
                  placeholder="Enter Status Color"
                  type="text"
                  value={newStatus.color}
                  onChange={(e) =>
                    setNewStatus({ ...newStatus, color: e.target.value })
                  }
                />
                <div className="add-status-btn-container">
                  <button
                    className="add-btn"
                    onClick={
                      statusEditable ? handleEditStatus : handleAddNewStatus
                    }
                  >
                    {statusEditable ? "Save" : "Add"}
                  </button>
                  <button
                    className="cancel-btn"
                    onClick={() => {
                      setCreateStatusDial(false);
                      setStatusEditable(false);
                      setNewStatus({ name: "", color: "" });
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          {deleteStatusDial && (
            <div className="delete-phase-dial">
              <div className="delete-dial">
                <div className="delete-header">
                  <h3
                    style={{
                      backgroundColor: "transparent",
                      marginLeft: "15px",
                      fontSize: "15px",
                    }}
                  >
                    Delete Status
                  </h3>
                </div>
                <div style={{ backgroundColor: "white" }}>
                  <p style={{ backgroundColor: "white" }}>
                    Are you sure you want to delete this Status. This action
                    cannot be undone.
                  </p>
                  <input
                    style={{ cursor: "pointer" }}
                    type="checkbox"
                    id="delete-phase"
                    checked={isCheckboxChecked}
                    onChange={() => setIsCheckboxChecked((prev) => !prev)}
                  />
                  <label
                    htmlFor="delete-phase"
                    style={{ backgroundColor: "white", cursor: "pointer" }}
                  >
                    I understand this action cannot be undone.
                  </label>
                </div>
                <div className="delete-dial-btn-con">
                  <button
                    onClick={() => handleDeleteStatus(selectedStatusIds)}
                    color="secondary"
                    variant="contained"
                    disabled={!isCheckboxChecked}
                    className="add-btn"
                    style={{
                      backgroundColor: isCheckboxChecked ? "red" : "gray",
                    }}
                  >
                    Delete
                  </button>

                  <button
                    onClick={() => {
                      setDeleteStatusDial(false);
                    }}
                    className="cancel-btn"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {openSection === "tasktemplate" && (
        <div
          className="settings-details"
          style={{ position: "relative", left: "3%" }}
        >
          <TaskTemplate />
        </div>
      )}
      {openSection === "estimatetemplate" && (
        <div
          className="settings-details"
          style={{ position: "relative", left: "3%" }}
        >
          <EstimateTaskTemplate />
        </div>
      )}
    </div>
  );
};

export default ProjectSettings;
